import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'

import useLimitReachedModal from './useLimitReachedModal'
import { ModalActions, ModalText } from '../styled-components'

const LimitReachedModal = () => {
  const { isOpen, isSubmitting, title, text, confirmLabel, setIsOpen, confirm } = useLimitReachedModal()

  return (
    <SDModal
      isOpen={isOpen}
      openHandler={setIsOpen}
      title={title}
      sections={
        <>
          <ModalText>{text}</ModalText>
          <ModalActions>
            {/* @ts-expect-error SDButton is a JS component */}
            <SDButton id='break-limit-confirm-btn' disabled={isSubmitting} onClick={confirm}>
              {confirmLabel}
            </SDButton>
          </ModalActions>
        </>
      }
    />
  )
}

export default LimitReachedModal
